import { Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useApiServiceContext } from "@bujus/common-frontend";

import {
    HorizontalCenterCircularProgress,
    HorizontalCenterErrorMessage,
    LoginButton,
} from "@/base";
import { useAccountDashboardTitleStateContext } from "@/contexts";

import { AccountRemovalPage__Logic } from "./account-removal-page__logic";

const AccountRemovalPage = () => {
    const params = useParams();

    const apiService = useApiServiceContext();
    const [, setAccountDashboardTitle] = useAccountDashboardTitleStateContext();

    const query = useQuery(
        ["_schools", "validateRemovalToken", params.token],
        async ({ queryKey: key }) => apiService.schools.validateRemovalTokenAsync(key[2]),
    );

    useEffect(() => {
        setAccountDashboardTitle("Account löschen");
    }, []);

    if (query.isLoading) {
        return <HorizontalCenterCircularProgress />;
    }
    if (query.isError) {
        return (
            <>
                <HorizontalCenterErrorMessage error={query.error} />
                <Box display="flex" justifyContent="center" mt={2}>
                    <LoginButton />
                </Box>
            </>
        );
    }
    if (query.isSuccess) {
        return (
            <>
                <Typography align="center" color="textSecondary">
                    Für {query.data.name} ({query.data.mailAddress})
                </Typography>
                <Box mt={2}>
                    <AccountRemovalPage__Logic token={params.token} />
                </Box>
            </>
        );
    }
    return undefined;
};

export { AccountRemovalPage };
